<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
  >
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="accent"
    ></v-progress-linear>

    <v-toolbar-title style="max-width: 300px">
      <v-app-bar-nav-icon class="drawer-toggle" @click.stop="toggleDrawer" />
      <span class="hidden-sm-and-down" v-if="currentUser">
        {{ currentUser.company }}
      </span>
    </v-toolbar-title>
    <v-spacer />

    <span>
      <v-btn class="mr-4" icon :to="{ name: 'TimeScan' }">
        <v-icon>mdi-clock</v-icon>
      </v-btn>
    </span>

    <span>
      <v-btn class="mr-4" icon :to="{ name: 'AdminMessages' }">
        <v-icon>mdi-bell-badge</v-icon>
      </v-btn>
    </span>

    <span v-if="showInstallIcon">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-4" icon @click="installApp" v-bind="attrs" v-on="on">
            <v-icon>mdi-download-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>Install as an App</span>
      </v-tooltip>
    </span>

    <v-btn data-cy="login" to="/login" v-if="!isLoggedIn" icon title="Login">
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <div v-if="currentUser" class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-0" tile large icon v-bind="attrs" v-on="on">
            <v-icon>mdi-shield-account</v-icon>
          </v-btn>
        </template>

        <v-card class="mx-auto" max-width="400" width="200" tile>
          <v-list dense>
            <v-list-item-group v-model="menuItem" color="primary">
              <v-list-item :to="{ name: 'EditProfile' }">
                <v-list-item-title>
                  {{ currentUser.firstName }} {{ currentUser.lastName }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="availableAccounts.length > 0"
                @click="openSwitchAccountDialog"
                :disabled="loadingAccounts"
              >
                <v-list-item-icon class="mr-2">
                  <v-progress-circular
                    v-if="loadingAccounts"
                    indeterminate
                    size="20"
                    width="2"
                    color="primary"
                  ></v-progress-circular>
                  <v-icon v-else>mdi-account-switch</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ loadingAccounts ? "Loading..." : "Switch Account" }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="item.link"
                v-for="(item, i) in userMenu"
                :key="i"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </div>
    <v-dialog v-model="switchAccountDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          Switch Account
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loadingAccounts"
            indeterminate
            size="24"
            width="2"
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <div v-if="loadingAccounts" class="text-center py-4">
            <v-progress-circular
              indeterminate
              size="40"
              width="3"
              color="primary"
            ></v-progress-circular>
            <p class="mt-3 text-body-2 grey--text">
              Loading available accounts...
            </p>
          </div>
          <v-radio-group v-else v-model="selectedAccount">
            <v-radio
              v-for="account in availableAccounts"
              :key="account.id"
              :label="account.name"
              :value="account.id"
              :disabled="switchingAccount"
            >
              <template v-slot:label>
                <div>
                  <div>{{ account.name }}</div>
                  <div class="text-caption grey--text">{{ account.email }}</div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <div v-if="switchingAccount" class="text-center py-4">
            <v-progress-circular
              indeterminate
              size="40"
              width="3"
              color="primary"
            ></v-progress-circular>
            <p class="mt-3 text-body-2 grey--text">Switching account...</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="switchAccountDialog = false"
            :disabled="loadingAccounts || switchingAccount"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!selectedAccount || loadingAccounts || switchingAccount"
            :loading="switchingAccount"
            @click="switchAcct(selectedAccount)"
          >
            Switch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data: () => ({
    selectedCenter: null,
    centerList: [],
    drawer: null,
    menuItem: 1,
    userMenu: [
      // {
      //   text: "My Home",
      //   link: "/secure/myhome",
      //   icon: "mdi-account",
      // },
    ],
    modules: [],
    switchAccountDialog: false,
    availableAccounts: [],
    selectedAccount: null,
    loadingAccounts: false,
    switchingAccount: false,
    switchAccountMessage: "",
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "currentUser",
      "isAppLoading",
      "globalCenter",
      "isClockedIn",
    ]),
    ...mapState("serviceWorker", ["showInstallIcon"]),
  },
  created() {
    this.fetchTimesheetRecords();
    this.$watch("isClockedIn", this.clockInStatusChanged);
  },
  async mounted() {
    //check jwt token all each page reload
    await this.remoteJwtTokenCheck();
    await this.fetchAvailableAccounts();

    if (!this.currentUser) return;

    this.initCenters()
      .then((centers) => {
        this.centerList = centers;
        if (this.centerList && this.centerList.length > 1) {
          this.centerList.unshift({
            id: null,
            name: "All Locations",
            accountId: this.centerList[0].accountId,
          });
        }
        this.setMyCenters(centers);

        this.selectedCenter = this.globalCenter;
        if (centers && centers.length > 0) {
          const existIndex = centers.findIndex(
            (c) => this.selectedCenter && c.id == this.selectedCenter.id,
          );
          if (!existIndex || existIndex < 0) {
            this.selectedCenter = centers[0];
            this.setCenter(this.selectedCenter);
          }
        }
      })
      .finally(() => {
        this.$emit("load", this.selectedCenter);
      });
  },
  methods: {
    ...mapActions([
      "toggleDrawer",
      "hideDrawer",
      "processLogout",
      "setCenter",
      "setMyCenters",
      "remoteJwtTokenCheck",
      "fetchTimesheetRecords",
      "updateUserToken",
    ]),
    ...mapActions("serviceWorker", ["triggerShowInstallIcon"]),
    installApp() {
      if (this.$store.state.serviceWorker.deferredPrompt) {
        // Replace with your Vuex state
        const promptEvent = this.$store.state.serviceWorker.deferredPrompt;
        promptEvent.prompt();
        promptEvent.userChoice.then((choiceResult) => {
          // if (choiceResult.outcome === "accepted") {
          //   console.log("User accepted the install prompt");
          // } else {
          //   console.log("User dismissed the install prompt");
          // }
          this.triggerShowInstallIcon(false);
        });
      }
    },
    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.processLogout();
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({ name: "Login" });
      });
    },
    changeCenter() {
      this.setCenter(this.selectedCenter);
      window.location.reload();
    },
    async initCenters() {
      return await this.$axios.get("/center/get-my-centers").then((resp) => {
        const centers = resp.data;
        return centers;
      });
    },
    clockInStatusChanged(newValue, oldValue) {
      // console.log(
      //   "clock in status changed....from " + oldValue + " to " + newValue,
      // );
    },
    async fetchAvailableAccounts() {
      this.loadingAccounts = true;
      try {
        const response = await this.$axios.get("/jwt-token-check");
        if (response.data && response.data.availableAccounts) {
          this.availableAccounts = response.data.availableAccounts.map(
            (account) => ({
              id: account.id,
              name: account.name,
              email: response.data.email,
            }),
          );
          // Sort accounts alphabetically by name (case-insensitive)
          this.availableAccounts.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.availableAccounts = [];
        }
      } catch (error) {
        this.availableAccounts = [];
      } finally {
        this.loadingAccounts = false;
      }
    },
    async openSwitchAccountDialog() {
      this.loadingAccounts = true;
      this.switchAccountDialog = true;
      try {
        const response = await this.$axios.get("/jwt-token-check");
        if (response.data && response.data.availableAccounts) {
          this.availableAccounts = response.data.availableAccounts.map(
            (account) => ({
              id: account.id,
              name: account.name,
              email: response.data.email,
            }),
          );
          // Sort accounts alphabetically by name (case-insensitive)
          this.availableAccounts.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.availableAccounts = [];
        }
      } catch (error) {
        this.availableAccounts = [];
      } finally {
        this.loadingAccounts = false;
      }
      this.selectedAccount = null;
    },
    async switchAcct(accountId) {
      this.switchingAccount = true;
      this.loadingAccounts = false;
      try {
        // Switch account on backend
        await this.$axios.post("/gaa-user/switch-account", null, {
          params: { accountId },
        });

        // clear local storage
        localStorage.removeItem("token");
        localStorage.removeItem("vuex");
        delete this.$axios.defaults.headers.common["Authorization"];

        window.location.reload();
      } catch (error) {
        this.switchingAccount = false;
        if (this.addErrorMessage) this.addErrorMessage(error);
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style>
.drawer-toggle {
  display: none !important;
}

@media (min-width: 640px) {
  .drawer-toggle {
    display: inline-flex !important;
  }
}
</style>
